// extracted by mini-css-extract-plugin
module.exports = {"Container":"CustomCardSubHeader_Container__3j9LM","Icon":"CustomCardSubHeader_Icon__ikSZ-"};